$.fn.filterMap = function(){
  const showAllCountry = "Show all"; 
  
  this.main = $(this);
  this.apiURL = this.main.attr('data-filterMap');
  this.mapContainer = this.main.find('[data-filterMap="map"]');
  this.listOutput = this.main.find('[data-filterMap="list"]');
  this.template = ` <div class="filterMap__instance">
                      <p class="filterMap__instance__title" data-id="{{id}}">{{ title }}</p>
                      {{ fields }}
                    </div>`;
  this.radioTemplate = `<label>
                        <span class="filterMap__radios__item">
                          <input type="radio" {{ checked }} name="type" value="{{ value }}" />
                          <span class="filterMap__radios__check"></span>
                        </span>
                        <span class="filterMap__radios__label">{{ value }}</span> 
                      </label>`;
  this.radioContainer = this.main.find('[data-filterMap="radios"]');

  this.selectContainer = this.main.find('[data-filterMap="select"]');

  this.markers = [];
  this.bounds = new google.maps.LatLngBounds();

  this.openInfowindow = false;
  this.mapOptions = {
    center: new google.maps.LatLng(-25.363882,131.044922),
    zoom: 10,
  }

  this.map = new google.maps.Map(this.mapContainer[0], this.mapOptions);

  this.regex = (key) => {
    return new RegExp(`{{\\s*${key}\\s*?}}`, 'img');
  }

  this.getData = () => {
    $.ajax({
      url: this.apiURL,
      method: 'GET',
      success: (response) => {
        this.origData = JSON.parse(JSON.stringify(response));
        this.data = response;
        this.createFormOptions();
        this.filterData();
        this.filterDataHide();
      }
    });
  }

  this.createFormOptions = () => {
    const types = this.origData.productOptions;
    const countries = this.origData.countries;

    const radioOutput = types.map((item, index) => {
      let tmp = this.radioTemplate.replace(this.regex('value'), item);
      if (index === 0) {
        //tmp = tmp.replace(this.regex('checked'), 'checked');
        tmp = tmp.replace(this.regex('checked'), '');
      } else {
        tmp = tmp.replace(this.regex('checked'), '');
      }
      return tmp;
    }).join('');

    this.radioContainer.html(radioOutput);
    
    let selectOutput = countries.map((item) => {
      return `<option value="${item}">${item}</option>`;
    }).join('');

    selectOutput =  `<option value="${showAllCountry}">${showAllCountry}</option>`+ selectOutput;

    this.selectContainer.html(`<select name="country">${selectOutput}</select>`);

    this.main.find('input,select').on('change', (e) => {      
      this.updateHash();
    });

    this.main.find("input[type='radio']").on("click",  function(e) {
      var checked = $(this).attr("checked");
      if(!checked){
          $(this).attr("checked", true);
      } else {
          $(this).removeAttr("checked");
          $(this).prop("checked", false);
      }
      $(this).trigger('change');
  });

    const fields =  Object.fromEntries(new URLSearchParams(window.location.search));

    if (fields.type) {
      this.main.find(`[name="type"][value="${fields.type}"]`).prop('checked', true);
    }

    if (fields.country) {
      this.main.find(`[name="country"]`).val(fields.country);
    }
  };

  this.updateHash = () => {
    const data = this.main.find('form').serialize();
    window.history.replaceState('', '', `?${data}`);
    this.filterData();
  }

  this.filterData = () => {
    this.fields = Object.fromEntries(new URLSearchParams(window.location.search)); 
    if (!this.fields) {
      this.fields = {};
    }

    if (!this.fields.type) {
      this.fields.type = this.main.find('input[name="type"]').filter(':checked').val();
    }
    if (!this.fields.country) {
      this.fields.country = this.main.find('[name="country"]').val();
    }

    const deepLink = JSON.parse(JSON.stringify(this.origData));
    
    this.data.list = deepLink.list.filter((item) => {
      let match = true;
      Object.keys(this.fields).forEach((key) => {
        let country = Object.keys(this.fields)[0];
        let type = Object.keys(this.fields)[0];

        if (!this.fields.type) {
          if (!(this.fields.country).toLowerCase().match(showAllCountry.toLowerCase())) { //  "option show all "
            if (!(item[country].toLowerCase().match((this.fields.country).toLowerCase()))) {
              match = false;
            }
          }
        }else if ((this.fields.country).toLowerCase().match(showAllCountry.toLowerCase())) {
          if (!(item[type].toLowerCase().match((this.fields.type).toLowerCase()))) {
            match = false;
          }
        } else if (!item[key].toLowerCase().match(this.fields[key].toLowerCase())) {
          match = false;
        }
      });
      return match;
    });

    this.addMarkers();
    this.createList();
  }
  
  this.createList = () => {
    let output = '';
    this.data.list.forEach((item, index) => {
      let fieldsOutput = ''
      item.fields.forEach((field) => {
        fieldsOutput+= `<p>${field}</p>`;
      });
      output+= this.template
              .replace(this.regex('title'), item.title)
              .replace(this.regex('id'), index)
              .replace(this.regex('fields'), fieldsOutput);
    });

    this.listOutput.html(output);
    this.listOutput.find('[data-id]').on('click', (e) => {
      e.preventDefault();
      const id = parseInt($(e.target).attr('data-id'));
      const marker = this.markers[id];
      try {
        if (this.openInfowindow) {
          this.openInfowindow.infowindow.close();
          this.openInfowindow = false;
        }
        this.openInfowindow = marker;
        marker.infowindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: false,
        });
      } catch(err) {
      }

    });
  }

  this.filterDataHide = () => {

    let data = $('select[name="country"');

    data.on('change', function () {
      let input = $(this).val();
      let dataToHide = $('.filterMap__list__scroller');

      if (input.toLowerCase() === showAllCountry.toLowerCase()) {
        dataToHide.hide();
      } else {
        dataToHide.show();
      }
    });

    data.change();
  }

  this.addMarkers = () => {
    this.markers.forEach((marker) => {
      marker.setMap(null);
    });
    this.markers = [];
    this.bounds = new google.maps.LatLngBounds();
    
    this.data.list.forEach((item) => {
      if (item.coords.lat && item.coords.lng) {
        
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(item.coords.lat, item.coords.lng),
          map: this.map,
          icon: '/assets/imgs/marker.svg',
          title: item.title,
        });


        let fieldsOutput = ''
        item.fields.forEach((field) => {
          fieldsOutput+= `<p>${field}</p>`;
        });

        marker.infowindow = new google.maps.InfoWindow({
          content: `
            <div class="infowindow">
              <div class="infowindow__title">${item.title}</div>
              <div class="infowindow__body">
                ${fieldsOutput}
              </div>
            </div>
          `,
        });
        
        marker.addListener("click", () => {
          if (this.openInfowindow) {
            this.openInfowindow.infowindow.close();
            this.openInfowindow = false;
          }
          this.openInfowindow = marker;
          marker.infowindow.open({
            anchor: marker,
            map: this.map,
            shouldFocus: false,
          });
        });
        
        this.markers.push(marker);
        this.bounds.extend(marker.position);
      }
    });

    if (this.bounds.isEmpty() ) {
      this.map.setZoom(2);
      this.map.setCenter(new google.maps.LatLng(0,0));
    } else {
      this.map.fitBounds(this.bounds);
      setTimeout(() => {
        const zoom = this.map.getZoom();
        if (zoom && zoom > 10) {
          this.map.setZoom(10);                
        } else { // full mapp custom zoom // changed to show more Europe
          let data = $('select[name="country"').val();
          if (data.toLowerCase() === showAllCountry.toLowerCase()) {
            this.map.setZoom(3);
            this.map.setCenter(new google.maps.LatLng(53.811836, 11.748343));  
          } 
        }
      }, 100);
    }
  }

  this.getData();
}